import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Toaster } from './components/ui/sonner.tsx'
import * as Sentry from "@sentry/react";
import { ThemeProvider } from 'next-themes'
import { AuthGuardProvider } from './components/AuthGuardProvider.tsx'

function init() {
  if (navigator.userAgent.includes("Firefox")) {
    return createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <div className="flex h-screen w-screen items-center justify-center text-center">
          <h1 className="text-2xl font-bold text-red-500">This app is not supported in Firefox. Please use Chrome or Edge for the best experience.</h1>
        </div>
      </StrictMode>,
    )
  }

  Sentry.init({
    dsn: "https://315352b808f9d5bdff9e3af1085ff4e7@o4509205060780032.ingest.us.sentry.io/4509205068775424"
  })

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <AuthGuardProvider>
          <App />
          <Toaster />
        </AuthGuardProvider>
      </ThemeProvider>
    </StrictMode>,
  )
}

init();